
export const tableTypes = {
    None: { id: "none", pagination: false },
    General: { id: "site", pagination: true, pageSize: 10 },
    Report: { id: "report", pagination: true, pageSize: 20 }, 
    Tool: { id: "tool", pagination: true, pageSize: 20 }
}

export const tableDefaults = tableTypes.General